// Follow the system theme by default, with a manual override (DESIGN.md "Theming"). The choice
// is a per-viewer convenience, so it lives in localStorage — never in the account.
export type ThemeChoice = 'system' | 'light' | 'dark';
const KEY = 'satori.theme';

export function storedTheme(): ThemeChoice {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'light' || v === 'dark') return v;
  } catch {
    /* system */
  }
  return 'system';
}

export function applyTheme(choice: ThemeChoice, persist = false): void {
  const root = document.documentElement;
  if (choice === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', choice);
  if (!persist) return;
  try {
    if (choice === 'system') localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, choice);
  } catch {
    /* the choice holds for this session */
  }
}
